import React from "react";
import './privacypolicy.css';

function MVatuCookiePolicy (){

    const openNewTab =(url)=>{
        window.open(url, '_blank')
    }
    return (
        <div style={{marginLeft:5, marginRight:5,}}>
                   
            <p style={{textAlign:'center', fontSize:28}}><strong>Our Cookies Policy</strong></p>

            <div>
                <p>
                    This section is about what cookies are, how we use them and how you can manage them.
                </p>
            </div>

            <div>
                <h3>
                    What are cookies?
                </h3>
                <p>
                Cookies are small files that are stored on your device when you visit a website. The cookies mean that the website
will remember you and how you've used the site every time you come back.
                </p>
                <p>
                If you want to know more about cookies, head to <a href="https://www.aboutcookies.org" target="_blank">aboutcookies.org</a> or <a href="https://allaboutcookies.org">allaboutcookies.org </a>(please note: these links
open a new window or browser tab).
                </p>

            </div>
            <div>
                <h3>
                How we use cookies
                </h3>
                <p>
                We use cookies to do a number of things. For example, remembering your preferences, recording what you've put in
your shopping basket, or counting the number of people looking at a website. We also use them to keep track of
what you've bought from us, what you've done on the site, and to make online advertising more relevant to you.
                </p>
                <p>
                Cookies themselves don't hold personal information. They only have a unique alphanumeric identifier that sits on
your browser. And in many cases, we won't be able to link the information we collect by using a cookie back to you.
They can, however, enable us to link that information back to you and your personal information, for example, when
you log in, or choose to register for a service, white paper or newsletter.
                </p>
                <p>
                    We've put our cookies into the following categories, to make it easier for you to understand why we need them:
                    <ol>
                        <li>Strictly necessary - these are used to help make our website work efficiently.</li>
                        <li>Performance - these are used to analyse the way our website works and how we can improve it.</li>
                        <li>Functionality - these help to enhance your experience by doing things like remembering products you've
added to your basket.</li>
                        <li>Targeting/advertising  these are used to share some information with third parties who we advertise with,
so we know how you've reached our website. We can also use cookies to identify the parts of the website
that you are interested in. We then use this information to show you adverts and pages we think may also
be of interest to you, to tailor how we communicate with you, or to tailor the contents of the
communications we send to you. If you prefer, you can opt out of these. Tailoring of content means it
includes information reflecting the interest you've shown in the content of our web pages, or offers or
promotions that we think may interest you, and to improve how we respond to your needs.</li>
                    </ol>
                </p>
            </div>
            <div>
                <p>
                    In addition to the cookies we use on our websites, we also use cookies and similar technologies in some emails and
                    push notifications we send to mobile devices from our apps. These help us to understand whether you have opened
                    the email and how you have interacted with it. If you have enabled images, cookies may be set on your computer or
                    mobile device. Cookies will also be set if you click on any link within the email.
                </p>
                <p>
                    We sometimes use persistent cookies as well as 'session-based' cookies. A 'persistent' cookie will remain for a period
                    of time set for that cookie. A 'session-based' cookie is allocated only for the duration of your visit to our website and
                    automatically expires when you close down your browser.
                </p>
            </div>
            <div>
                <h3>Cookies and you</h3>
                <p>
                    To make a purchase online or sign up to services like My Vodafone or Vodafone Rewards on Pay as you go, you
    must have cookies enabled on your internet browser. Some of the more popular browsers are:
                </p>
                <ul>
                    <li>Internet Explorer</li>
                    <li>Firefox</li>
                    <li>Safari</li>
                    <li>Google Chrome</li>
                </ul>
                <p>
                If you choose not to enable cookies, you'll still be able to browse our website, but it will restrict some of the
functionality of our website and what you can do.
                </p>

            </div>

            <div>
                <h3>
                    First-party cookies
                </h3>
                <p>
                    First-party cookies originate from the same domain as the website you're currently visiting (in this case,
                    www.vodafone.com.vu).
                </p>
                <p>
                    See our list of first-party cookies (shown later on in this cookies policy).
                </p>

                <h3>
                    Third-party cookies
                </h3>
                <p>
                    Third-party cookies originate from a domain that's different to the website being visited. For example, when you
                    visit our website, we may link to another company's website - like our Facebook or Twitter account, or a video from
                    our YouTube page. We don't control how they use their cookies, so we suggest you check their website to see how
                    they're using them and how you can manage them.
                </p>
                
                
            </div>
            <div>
                <h3>
                    Controlling your cookies
                </h3>
                <p>
                    You can opt in or out of cookies at any time - except strictly necessary cookies (these are used to help make our
                    website work efficiently). Click on the cookie settings button to control your cookies, and toggle each cookie to
                    Active or Inactive. You can select by category or individual cookie.
                </p>
                <p>
                    Go to Cookies Settings
                </p>
                <p>
                    Alternatively, you can enable or disable cookies in your browser. If you wish to restrict or block the cookies set by
                    any website - including a Vodafone website - you can do this through the web browser settings for each web
                    browser you use, on each device you use to access the internet.
                </p>
                <p>
                    Information on controlling and deleting cookies, including on a wide variety of browsers, is also available at&nbsp;
                    <a href="https://allaboutcookies.org" target="_blank">allaboutcookies.org </a>
                </p>
                <p>
                    In our cookie policy under the heading 'Cookies and you', we've also provided a few links for some of the more
                    popular browsers - but check your particular browser and device for correct and up-to-date information.
                </p>
                <p>
                    Some services - M-Vatu app, for example - may not function or may have more limited functionality if your web
                    browser does not accept cookies. However, you can allow cookies from specific websites by making them 'trusted
                    websites' in your web browser.
                </p>
                <p>
                    If you don't wish to accept cookies from one of our emails, you can choose not to download any images or click on
                    any links. You can also set your browser to restrict cookies or to reject them entirely. These settings will apply to all
                    cookies, whether included on websites or in emails. Depending on your email or browser settings, cookies in an

                    email may sometimes be automatically accepted (for example, when you've added an email address to your address
                    book or safe senders list). For more information, refer to your email browser or device instructions.
                </p>
            </div>
            

            
        </div>
    
    )
}

export default MVatuCookiePolicy;